import { CYRILLIC } from './cyrillic';
import { CYRILLIC_EXT } from './cyrillic-ext';
import { DEVANGARI } from './devanagari';
import { GREEK } from './greek';
import { GREEK_EXT } from './greek-ext';
import { LATIN } from './latin';
import { LATIN_EXT } from './latin-ext';

export * from './postConfigs';
export * from './tabEvents';

/**
 * TEMPORARY
 * These are noto sans fonts with a base64 encoding of the font src
 * This is needed for the petition title image generation, which needs to embed the font
 * in the svg in order to draw the text into a canvas element
 */
export const FONT_STYLE = `
${CYRILLIC}
${CYRILLIC_EXT}
${DEVANGARI}
${GREEK}
${GREEK_EXT}
${LATIN_EXT}
${LATIN}
`;

/**
 * Height of the dashboard bottom navigation bar (in pixels).
 * Used to offset fixed bottom elements so they don't overlap the nav.
 */
export const DASHBOARD_BOTTOM_NAV_HEIGHT_PX = 69;
